import React from 'react';

import { type WrapProps } from './types';

const Wrap = ({ when, within, children }: WrapProps) => (when ? within(children) : <>{children}</>);

export { Wrap };
